<!--
  列表页头部组件
  props:
    placeholder: 搜索框的提示文字
  emit:
    searchEmit: 提交搜索请求
 -->

<template>
  <div class="children-head">
    <h1 class="title">
      <slot name="back"></slot>
      <slot name="title"></slot>
    </h1>
    <div class="template">
      <slot name="template"></slot>
    </div>
    <div class="search" v-show="showSearch">
      <template v-if="moduleName=='workOrder'">
        <el-input 
        :placeholder="'请输入'+selectLable"
        v-model="search"
        @change.native="searchKeydown"
        class="input-text">
          <el-select v-model="searchType" slot="prepend" placeholder="请选择">
            <el-option label="工单编号" value="0"></el-option>
            <el-option label="合同" value="1"></el-option>
            <el-option label="客户" value="2"></el-option>
            <el-option label="机会" value="5"></el-option>
          </el-select> 
        </el-input>
        <i class="el-icon-close" v-if="search" @click="clearValue"></i>
      </template>
      <template v-else>
        <input class="input-text" type="text" :placeholder="placeholder" v-model="search" @change="searchKeydown">
        <i class="el-icon-close" v-if="search" @click="clearValue"></i>
      </template>
    </div>
    <div class="options">
      <slot name="options"></slot>
      <slot name="otherBtn"></slot>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  props: {
    placeholder: {
      type: String,
      default: '请输入搜索内容'
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    moduleName: {
      type: String
    },
    nameLike: {
      type: String
    }
  },
  data () {
    return {
      search: this.nameLike || '',
      searchType: '0'
    }
  },
  // mounted () {
  //   alert(this.moduleName)
  // },
  methods: {
    ...mapActions([
      'setSidemenuStatus'
    ]),
    clearValue (attr) {
      this.search = ''
      this.searchKeydown()
    },
    searchKeydown () { // 按下键盘回车才会执行搜索
      if (this.moduleName === 'workOrder') {
        this.$emit('searchEmit', [this.search, this.searchType])
      } else {
        this.$emit('searchEmit', this.search)
      }
    }
  },
  computed: {
    selectLable () { // 搜索输入框随选择类型改变placeholder
      switch (this.searchType) {
        case '0' :return '工单编号'
        case '1' :return '合同'
        case '2' :return '客户'
        case '5' :return '机会'
      }
    }
  },
  watch: {
    searchType () { // 工单搜索选项改变时触发
      this.$emit('searchEmit', [this.search, this.searchType])
    }
  }
}
</script>


<style lang="less">
@import "../../assets/less/variable.less";
.pendingOrder {
  .children-head {
    .title {
      top: 15px;
    }
  }
}
.children-head {
  position: relative;
  height: 60px;
  background-color: #fff;
  text-align: right;
  font-size: 0;
  flex: 0 0 60px;
  .title {
    float: left;
    margin-left: 20px;
    font-size: 16px;
    color: #222;
    line-height: 60px;
  }
  .template {
    float: left;
    margin-left: 30px;
    color: #060606;
    line-height: 60px;
    .template-box {
      .template-item {
        display: inline-block;
        margin-right: 32px;
        height: 45px;
        cursor: pointer;
        outline: none;
        font-size: 12px;
        padding: 0 5px;
        &.active {
          color: #FF9800;
          border-bottom: 2px solid #FF9800;
        }
      }
    }
  }
  .search,.options {
    display: inline-block;
    margin-right: 25px;
    margin-top: 12px;
  }
  .search {
    position: relative;
    .el-select{
      width:100px;
    }
    .el-input__inner{
      height: 34px;
    }
    .input-text {
      box-sizing: border-box;
      padding: 0 10px;
      border-radius: 2px;
      background-color: #f5f9ff;
      height: 32px;
      line-height: 32px;
      width: 220px;
      font-size: 13px;
    }
    .el-input-group{
      width:300px;
      padding: 0
    }
    .input-text + .el-icon-close {
      position: absolute;
      right: 10px;
      top: 10px;
      font-size: 12px;
      color: @primary;
      cursor: pointer;
      transform: scale(0.8);
    }
  }
  .options {
    .el-button,
    .el-dropdown {
      margin-left: 15px;
      &:first-child {
        margin-left: 0;
      }
      i {
        font-size: 10px;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// list-head.vue?2f98926d